import React, { useState } from "react";
import { Card, Col, Form, Input, Row, Upload } from "antd";
import { InboxOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dispatch } from "../../../../redux/store";
import { postGroup } from "../../../../redux/action/groups";
import { openNotification } from "../../../../global/item/Notification/Notification";
import Loading from "../../../../global/item/Loading/loading";
import ButtonBottom from "../../../../global/item/ButtonComponent/ButtonBottom";

const { Dragger } = Upload;

function DataScreen() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  /* ===================== HANDLE UPLOAD ===================== */
  const handleFileChange = (info: any) => {
    const file = info.file.originFileObj;
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        setUploadedImage(e.target.result.toString());
      }
    };
    reader.readAsDataURL(file);
  };

  const handleCloseImg = () => {
    setUploadedImage(null);
    form.setFieldValue("image", undefined);
  };

  /* ===================== SUBMIT ===================== */
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();

      let imageUrl: string | undefined = undefined;

      // Upload ảnh lên Cloudinary
      if (uploadedImage) {
        try {
          const file = await fetch(uploadedImage).then((res) => res.blob());
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", "hoatuoi");

          const res = await fetch(
            "https://api.cloudinary.com/v1_1/dcxwarx50/image/upload",
            {
              method: "POST",
              body: formData,
            }
          );

          const data = await res.json();
          imageUrl = data.secure_url;
        } catch (error) {
          openNotification({
            type: "error",
            message: "Lỗi upload ảnh",
            description: "Không thể upload ảnh lên Cloudinary",
          });
          setLoading(false);
          return;
        }
      }

      await dispatch(
        postGroup({
          groupName: values.groupName,
          description: values.description,
          image: imageUrl, // ✅ CHỈ 1 ẢNH
        })
      );

      openNotification({
        type: "success",
        message: t("update"),
        description: t("messUpdate"),
      });

      navigate("/category/data");
    } catch (error) {
      openNotification({
        type: "error",
        message: "Lỗi",
        description: "Dữ liệu không hợp lệ!",
      });
    } finally {
      setLoading(false);
    }
  };

  /* ===================== RENDER ===================== */
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <Form
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          requiredMark={false}
        >
          {/* ================= BASIC INFO ================= */}
          <Card className="layoutItem">
            <h3 style={{ color: "var(--primary-color)", marginBottom: 8 }}>
              {t("basicInformation")}
            </h3>
            <Row gutter={[20, 0]}>
              <Col xl={12}>
                <Form.Item
                  label="Tên danh mục"
                  name="groupName"
                  rules={[
                    { required: true, message: "Vui lòng nhập tên danh mục" },
                  ]}
                >
                  <Input placeholder="Nhập tên danh mục" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item
                  label="Mô tả"
                  name="description"
                  rules={[
                    { required: true, message: "Vui lòng nhập mô tả" },
                  ]}
                >
                  <Input placeholder="Nhập mô tả" />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* ================= IMAGE ================= */}
          <Card className="layoutItem">
            <h3 style={{ color: "var(--primary-color)" }}>
              {t("imageInfo")}
            </h3>

            <Row gutter={[20, 0]} style={{ margin: "16px 0" }}>
              <Col xl={24}>
                {uploadedImage ? (
                  <div style={{ position: "relative" }}>
                    <CloseOutlined
                      onClick={handleCloseImg}
                      className="iconCustom"
                      style={{
                        position: "absolute",
                        right: 24,
                        top: 12,
                        zIndex: 10,
                        fontSize: 18,
                      }}
                    />
                    <img
                      src={uploadedImage}
                      alt="Uploaded"
                      style={{
                        width: "100%",
                        height: 400,
                        objectFit: "contain",
                        borderRadius: 10,
                        padding: 10,
                        background: "rgba(0,0,0,0.02)",
                        border: "1px solid #eee",
                      }}
                    />
                  </div>
                ) : (
                  <Form.Item
                    name="image"
                    rules={[
                      { required: true, message: "Vui lòng chọn ảnh!" },
                    ]}
                  >
                    <Dragger
                      multiple={false}
                      showUploadList={false}
                      onChange={handleFileChange}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Click hoặc kéo thả ảnh vào đây
                      </p>
                      <p className="ant-upload-hint">
                        Chỉ hỗ trợ 1 ảnh
                      </p>
                    </Dragger>
                  </Form.Item>
                )}
              </Col>
            </Row>

            <p style={{ margin: 0 }}>Size khuyến nghị: 1920 x 875</p>
          </Card>

          {/* ================= BUTTON ================= */}
          <ButtonBottom
            onContinueClick={handleSubmit}
            btnCancel={t("cancel")}
            btnContinue={t("continue")}
          />
        </Form>
      )}
    </div>
  );
}

export default DataScreen;
